import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { usePermissionRules } from 'hooks/permissionRules';
import history from 'services/history';
import { useSurgerie } from '../../hooks/useSurgerie';

type SurgerieMenuProps = {
  anchorEl: HTMLButtonElement | null;
};

const SurgerieMenu: React.FC<SurgerieMenuProps> = ({ anchorEl }) => {
  const { selectedSurgerie, setAnchorEl, setSelectedSurgerie, setCloseSurgerie } = useSurgerie();
  const { checkPermission } = usePermissionRules();

  function handleClose() {
    setAnchorEl(null);
  }

  function handleCloseAndClear() {
    handleClose();
    setSelectedSurgerie(null);
  }

  function handlePrint() {
    window.open(`/surgeries/${selectedSurgerie?.status}/${selectedSurgerie?.id_int}/print`, '_blank');
    handleCloseAndClear();
  }

  function handleOpen() {
    history.push(`/surgeries/${selectedSurgerie?.id_int}`);
  }

  function handleFinish() {
    handleClose();
    setCloseSurgerie(true);
  }

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseAndClear}>
      <MenuItem onClick={handleOpen}>Abrir orçamento</MenuItem>
      <MenuItem onClick={handlePrint}>Imprimir orçamento</MenuItem>
      <MenuItem disabled={!checkPermission('surgeries.open.close')} onClick={handleFinish}>
        Fechar orçamento
      </MenuItem>
    </Menu>
  );
};

export default SurgerieMenu;
